<div>
  <iframe
    width="100%"
    [style.height.px]="data.height"
    [src]="data.url | safe"
  ></iframe>
</div>
